var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-bottom-dialog",on:{"click":_vm.close}},[_c('div',{ref:"dialogContainer",staticClass:"dialog-container",class:{ 'dialog-ani': _vm.isAni }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }